import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "scope", "book", "accessFields", "oneTimeFields", "subscriptionFields", "percentageFields", "subscriptionBenefitFields", "combinedFields", "affiliateFields"]
  static values = { configurationLocked: Boolean }

  connect() {
    this.change()
  }

  change() {
    const category = this.hasCategoryTarget ? this.categoryTarget.value : "access"
    this.toggleSection(this.accessFieldsTargets, category === "access")
    this.toggleSection(this.oneTimeFieldsTargets, ["one_time_discount", "combined_discount"].includes(category))
    this.toggleSection(this.subscriptionFieldsTargets, ["subscription_discount", "combined_discount"].includes(category))
    this.toggleSection(this.percentageFieldsTargets, category !== "access")
    this.toggleSection(this.subscriptionBenefitFieldsTargets, category === "subscription_discount")
    this.toggleSection(this.combinedFieldsTargets, category === "combined_discount")

    // Affiliate changes apply to future checkouts; existing contracts keep their snapshot.
    this.affiliateFieldsTargets.forEach((section) => {
      section.hidden = category === "access"
      section.querySelectorAll("input, select").forEach((input) => {
        input.disabled = category === "access"
      })
    })

    if (!this.hasScopeTarget || !this.hasBookTarget) return

    const bookAccess = category === "access" && this.scopeTarget.value === "book"
    this.bookTarget.hidden = !bookAccess
    this.bookTarget.querySelector("select").disabled = this.configurationLockedValue || !bookAccess
  }

  toggleSection(sections, visible) {
    sections.forEach((section) => {
      section.hidden = !visible
      section.querySelectorAll("input, select").forEach((input) => {
        if (input.matches("[data-controller~='tom-select']")) return

        input.disabled = this.configurationLockedValue || !visible
      })
    })
  }
}
